module.exports = __webpack_public_path__ + "static/media/start-right-arrrow.8adbe9cd.png";